import { render, staticRenderFns } from "./ArticleInfo.vue?vue&type=template&id=430a6d48&scoped=true&"
import script from "./ArticleInfo.vue?vue&type=script&lang=ts&"
export * from "./ArticleInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleInfo.vue?vue&type=style&index=0&id=430a6d48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430a6d48",
  null
  
)

export default component.exports